export const PAGE_GROUP_PREVIEW_MESSAGE_TYPE = "page-group-preview" as const;

export type GroupPreviewMessageType = typeof PAGE_GROUP_PREVIEW_MESSAGE_TYPE;

export type GroupPreviewAction = "subscribe" | "set" | "clear";

export type PageGroupPreviewMessage = {
  type: GroupPreviewMessageType;
  action: GroupPreviewAction;
  pageId: string;
  pageGroupId?: string;
};

export type GroupPreviewSnapshotMessageType = {
  type: GroupPreviewMessageType;
  action: "snapshot";
  pageId: string;
  preview: Record<string, string>;
};

export type SectionPageGroupPreviewType = GroupPreviewSnapshotMessageType & {
  sectionId: string;
};
